/* eslint-disable react/no-multi-comp */
import React, {Component, Fragment} from 'react';
import {
    AutocompleteArrayInput,
    BooleanInput,
    BulkDeleteButton,
    downloadCSV,
    Filter,
    FunctionField,
    List,
    Pagination,
    SelectInput,
    TextField,
    DateField,
    TextInput,
    translate
} from 'react-admin';
import {publicationStatusChoices} from '~constants/fieldGroups';
import {can, DELETE_PROYECTO} from '~utils/permissions';
import {parse} from 'json2csv';

import CustomDatagrid from '~components/CustomDatagrid';
import {IirsaCountriesService} from '~config/services/iirsa_countries.service';
import {RoutesService} from "~config/services/routes.service";
import {EtapasService} from '~config/services/etapas.service';
import {FinanciadoresEstudiosService} from '~config/services/financiadores_estudios.service';
import {SectorsService} from '~config/services/sectors.service';
import NumberBetweenInput from '../components/NumberBetweenInput';
import FiltersNestedSelectInput from "../components/FiltersNestedSelectInput";
import CustomDateField from "../../../components/CustomDateField";

class ProjectFilter extends Component {
    state = {
        countries: [],
        routes: [],
        etapas: [],
        financiadores: [],
        sectors: []
    };

    constructor() {
        super();
        const cs = new IirsaCountriesService();
        cs.get_la().then(r => this.setState({countries: r.data}));

        const rs = new RoutesService();
        rs.get().then(r => this.setState({routes: r.data}));

        const es = new EtapasService();
        es.get().then(r => this.setState({etapas: r.data}));

        const fs = new FinanciadoresEstudiosService();
        fs.get().then(r => this.setState({financiadores: r.data}));

        const ss = new SectorsService();
        ss.get().then(r => this.setState({sectors: r.data}));
    }

    render() {
        return (
            <Filter {...this.props}>
                <TextInput source="code" label="Código"/>
                <TextInput source="name" label="Nombre"/>

                <FiltersNestedSelectInput
                    label="Sector"
                    source="sector"
                    fstSource="id"
                    sndSource="id_subsector"
                    fstLabel="Sector"
                    sndLabel="Subsector"
                    fstChoices={this.state.sectors}
                    // eslint-disable-next-line react/jsx-no-bind
                    getSndChoices={fstValue => [{id: null, name: ''}, ...fstValue.subsectors]}
                />

                <SelectInput source="iirsa_funding_source" choices={this.state.financiadores} label="Financiamiento"/>
                <SelectInput source="iirsa_stage" choices={this.state.etapas} label="Etapa"/>
                {/*<SelectInput source="iirsa_status" choices={iirsaStatusChoices} label="Estado"/>*/}
                {/*<BooleanInput source="accompaniment" label="Acompañamiento"/>*/}

                <AutocompleteArrayInput
                    label="Paises"
                    source="iirsa_countries"
                    choices={this.state.countries}
                    sorteable={false}
                />

                <SelectInput
                    label="Agrupaciones de proyectos"
                    source="route_id"
                    choices={this.state.routes}
                    sorteable={false}
                />

                <NumberBetweenInput source="iirsa_total_investment" label="Inversión Total"/>

                <SelectInput
                    source="publication_status"
                    label="Estado de publicación"
                    choices={publicationStatusChoices}
                />
            </Filter>
        );
    }
}

const PostPagination = props => <Pagination rowsPerPageOptions={[50, 100]} {...props} />;

function formatProject(p) {
    delete p.starredAt;
    // delete p.kmlSimplified;
    delete p.dynamicMapZoom;
    delete p.staticMapZoom;
    delete p.dynamicCenterLatitude;
    delete p.dynamicCenterLongitude;
    delete p.dynamicCenter;
    delete p.staticCenter;
    delete p.projectType;
    delete p.sources;
    delete p.editable;
    delete p.createdAt;
    delete p.updatedAt;
    delete p.totalInvestment;
    delete p.galleryItems;
    delete p.link;

    p.Sector = p.iirsaSector ? p.iirsaSector.name : '';
    delete p.iirsaSector;

    p.Subsector = p.iirsaSubsector ? p.iirsaSubsector.name : '';
    delete p.iirsaSubsector;

    p.Etapa = p.iirsaStage ? p.iirsaStage.name : '';
    delete p.iirsaStage;

    p.Estado = p.iirsaStatus ? p.iirsaStatus.name : '';
    delete p.iirsaStatus;

    p.Alcance = p.iirsaScope ? p.iirsaScope.name : '';
    delete p.iirsaScope;

    p.Tipo_de_Obra = p.iirsaProjectType ? p.iirsaProjectType.name : '';
    delete p.iirsaProjectType;

    p.Estado_de_los_Estudios = p.iirsaStudiesState ? p.iirsaStudiesState.name : '';
    delete p.iirsaStudiesState;

    p.Financiador_de_los_Estudios = p.iirsaStudiesFunder ? p.iirsaStudiesFunder.name : '';
    delete p.iirsaStudiesFunder;

    // let elements = p.iirsaProjectFunding;
    // if (elements && elements.length > 0) {
    //     for(let i = 0; i <  elements.length; i++) {
    //         const prefix = 'FINANCIAMIENTO_' + (i + 1).toString() + '_';
    //         p[prefix + 'MONTO'] = elements[i].amount;
    //         p[prefix + 'TIPO'] = elements[i].fundingType ? elements[i].fundingType.name : "";
    //         p[prefix + 'FINANCIADOR'] = elements[i].funder ? elements[i].funder.name : "";
    //         p[prefix + 'ESTADO'] = elements[i].fundingStatus ? elements[i].fundingStatus.name : "";
    //     }
    // }
    // delete p.iirsaProjectFunding;
    delete p.iirsaSegments;
    delete p.iirsaLink;
    delete p.iirsaCountries;
}

const exporter = proj => {
    try {
        proj.forEach(p => {
            formatProject(p);
        });
        const formattedCsv = parse(proj);
        downloadCSV(formattedCsv, 'Proyectos');
    } catch (e) {
        console.error('Export error:', e);
        console.error('Projects data:', JSON.stringify(proj, null, 2));
    }
};

const BulkActions = props => (
    <Fragment>
        <BulkDeleteButton undoable={false} {...props} />
    </Fragment>
);

function IirsaProjectList(props) {
    const dateFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    };

    return (
        <>
            <List
                {...props}
                // `false` also drops the row checkboxes, so users who can't delete
                // (country managers) don't get a selection UI that leads nowhere.
                bulkActionButtons={can(props.permissions, DELETE_PROYECTO) ? <BulkActions/> : false}
                exporter={exporter}
                filters={<ProjectFilter/>}
                pagination={<PostPagination/>}
                perPage={50}
            >
                <CustomDatagrid rowClick="show">
                    <TextField source="id" sortBy="codigo"/>
                    <TextField source="name" label="Nombre" sortBy="nombre"/>
                    <TextField source="route.name" label="Agrupación de proyectos" sortBy={'ruta__nombre'}/>
                    <TextField source="countries" sortBy={'paises_string'}/>
                    <DateField source="createdAt" showTime locales={'es-AR'} options={dateFormatOptions}/>
                    <DateField source="updatedAt" showTime locales={'es-AR'} options={dateFormatOptions}/>
                    <TextField style={{textAlign: 'right'}} source="totalInvestmentFormatted" sortBy={'total_investment'}/>
                    <FunctionField
                        label="Publicación"
                        render={record => {
                            const choice = publicationStatusChoices.find(c => c.id === record.publicationStatus);
                            return choice ? choice.id === 'published' ? 'Publicado' : 'No Publicado' : '';
                        }}
                    />
                </CustomDatagrid>
            </List>
        </>
    );
}

export default translate(IirsaProjectList);
